<template>
  <form @submit.prevent="onSubmit">
    <b-field
      :message="$v.old_password.msg"
      :type="$v.old_password.status"
      horizontal
      label="Old Password"
    >
      <b-input
        placeholder="Password"
        type="password"
        v-model="form.old_password"
      />
    </b-field>
    <b-field
      :message="$v.new_password.msg"
      :type="$v.new_password.status"
      horizontal
      label="New Password"
    >
      <b-input
        placeholder="New Password"
        type="password"
        v-model="form.new_password"
      />
    </b-field>
    <b-field
      :message="$v.conf_password.msg"
      :type="$v.conf_password.status"
      horizontal
    >
      <b-input
        placeholder="Confirm Password"
        type="password"
        v-model="form.conf_password"
      />
    </b-field>
    <hr />
    <div ref="submit">
      <b-field horizontal>
        <b-button :loading="isLoading" native-type="submit" type="is-primary">
          Submit
        </b-button>
      </b-field>
    </div>
  </form>
</template>

<script>
import { changePassword } from '@/api/user'
import formMixin from '@/mixins/form'
import validationMixin from '@/mixins/validation'
import { required, sameAs } from '@/utils/validation'

export default {
  mixins: [formMixin, validationMixin],
  props: {
    userId: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      isLoading: false,
      rules: {
        old_password: [required],
        new_password: [required],
        conf_password: [required, sameAs(this, 'new_password')]
      },
      form: {
        old_password: null,
        new_password: null,
        conf_password: null
      }
    }
  },
  methods: {
    submit() {
      return changePassword({
        id: this.userId,
        ...this.form
      })
        .then(() => {
          this.$router.back()
        })
    }
  }
}
</script>
